import create from "zustand";

const useData = create(set => ({
    info: {
        dni: ''
    },
    setInfo: (data) => set(state => ({ info: data }))
}))
  
export default useData;